const myDropdown = document.querySelector(".navbar");
const hamburgers = document.querySelectorAll(".hamburger");
const navbar = document.querySelector(".navbar");
// Function to check for touch device
function isTouchDevice() {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0;
}

// Manage the hamburger and scrolling on show
navbar.addEventListener("show.bs.collapse", () => {
  hamburgers.forEach((hamburger) => hamburger.classList.add("is-active"));
  if (isTouchDevice()) {
    document.body.classList.add("no-scroll");
  }
});

// Manage the hamburger and scrolling on hide
navbar.addEventListener("hide.bs.collapse", () => {
  hamburgers.forEach((hamburger) => hamburger.classList.remove("is-active"));
  if (isTouchDevice()) {
    document.body.classList.remove("no-scroll");
  }
});

// Add event listener for clicks outside the nav menu
document.addEventListener("click", (event) => {
  if (
    !navbar.contains(event.target) &&
    !Array.from(hamburgers).some((hamburger) =>
      hamburger.contains(event.target),
    )
  ) {
    hamburgers.forEach((hamburger) => hamburger.classList.remove("is-active"));

    // Re-enable scrolling
    if (isTouchDevice()) {
      document.body.classList.remove("no-scroll");
    }
  }
});

// Close the mobile menu when the "Jetzt anfragen" button is tapped.
const navbarCollapse = document.getElementById("navbarNav");
navbarCollapse?.querySelectorAll('a.button[href^="#"]').forEach((link) => {
  link.addEventListener("click", () => {
    if (navbarCollapse.classList.contains("show")) {
      document.querySelector(".hamburger")?.click();
    }
  });
});
